import { render } from "./GiftcardDesignAddon.vue?vue&type=template&id=3f841d0a"
import script from "./GiftcardDesignAddon.vue?vue&type=script&lang=js"
export * from "./GiftcardDesignAddon.vue?vue&type=script&lang=js"

import "./GiftcardDesignAddon.vue?vue&type=style&index=0&id=3f841d0a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__